import script from "./CommentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentsView.vue?vue&type=script&setup=true&lang=js"

import "./CommentsView.vue?vue&type=style&index=0&id=07a40f06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a40f06"]])

export default __exports__